import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { ErrorStateService } from '@fgb/core';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'fgb-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  errorCode$: Observable<string>;

  constructor(
    private router: Router,
    public errorService: ErrorStateService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    if (this.authService.hasCurrentRefreshToken()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.errorCode$ = this.route.queryParams.pipe(map((query) => query['errorCode']));
  }
}
